const OCEAN_LEARNING_APP_USER_AGENT = 'OceanLearningApp'

class MobileNativeUtils {
  checkOceanLearningAppUserAgent() {
    const { userAgent } = window?.navigator
    return userAgent.includes(OCEAN_LEARNING_APP_USER_AGENT)
  }

  postMessageIOS(message: string) {
    if (!this.checkOceanLearningAppUserAgent()) return
    ;(window as any)?.webkit?.messageHandlers?.jsMessageHandler?.postMessage(message)
  }

  elearningStarted() {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS('OCEAN_ELEARNING_STARTED')
    ;(window as any)?.Android?.onElearningStarted()
  }

  elearningFinished() {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS('OCEAN_ELEARNING_FINISHED')
    ;(window as any)?.Android?.onElearningFinished()
  }

  enterElearningDetails(elearningId: string) {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS(`OCEAN_ENTER_ELEARNING_DETAILS ID:${elearningId}`)
    ;(window as any)?.Android?.enterElearningDetails(elearningId)
  }

  downloadElearning(elearningId: string) {
    if (!this.checkOceanLearningAppUserAgent()) return
    ;(window as any).ReactNativeWebView.postMessage(
      JSON.stringify({
        requestedAction: 'Download E-Learning',
        elearning_id: elearningId,
      })
    )
  }

  loggedOut() {
    if (!this.checkOceanLearningAppUserAgent()) return
    ;(window as any).ReactNativeWebView.postMessage(JSON.stringify({ requestedAction: 'logout' }))
  }

  sessionExpired() {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS('OCEAN_SESSION_EXPIRED')
    ;(window as any)?.Android?.onSessionExpired()
  }

  redirectToHome() {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS('OCEAN_APPLICATION_ERROR_GO_HOME')
    ;(window as any)?.Android?.onBackToHomeClicked()
  }

  goToSettings() {
    if (!this.checkOceanLearningAppUserAgent()) return
    this.postMessageIOS('OCEAN_SHOW_APP_SETTINGS')
    ;(window as any)?.Android?.onShowAppSettings()
  }

  goToDownloadedContent() {
    if (!this.checkOceanLearningAppUserAgent()) return
    ;(window as any).ReactNativeWebView.postMessage(
      JSON.stringify({ requestedAction: 'Open Downloads' })
    )
  }
}

export default new MobileNativeUtils()
